import React from "react";
import { Play } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import ReferShare from "../../Images/demoUserForNavbar.jpg";

const testimonials = [
  {
    name: "NITIN JAISWAL",
    plan: "Adhyayi GK Plan",
    review: "Earned 5000 credits while preparing—fun + learning",
  },
  {
    name: "PRIYA DESHMUKH",
    plan: "Adhyayi Ultimate Plan",
    review: "Best platform for students.",
  },
  {
    name: "AMAN VERMA",
    plan: "Civil Service Champion Plan",
    review: "Very easy to learn and earn.",
  },
  {
    name: "RAHUL SHARMA",
    plan: "Government Exam Combo Plan",
    review: "Loved the experience.",
  },
  {
    name: "SNEHA PATIL",
    plan: "Adhyayi GK Plan",
    review: "Amazing teaching style.",
  },
  {
    name: "VIKAS YADAV",
    plan: "Adhyayi Ultimate Plan",
    review: "Good mentors and support.",
  },
  {
    name: "ANJALI MORE",
    plan: "Government Exam Combo Plan",
    review: "Really helped me improve.",
  },
  {
    name: "ROHIT SINGH",
    plan: "Adhyayi GK Plan",
    review: "Worth every rupee.",
  },
];

export default function Testimonials() {
  return (
   <div
  id="Testimonials"
  className="overflow-hidden bg-white py-10 md:py-16 font-poppins " 
>
      <div className="mx-auto max-w-7xl px-6">
     <div className="mb-8 md:mb-12 text-center">
  <p className="mb-2 text-[10px] sm:text-xs uppercase tracking-[0.2em] sm:tracking-[0.35em] text-slate-500">
    Student Success Stories
  </p>

  <h2 className="text-xl sm:text-3xl md:text-4xl font-bold text-slate-900 leading-snug">
    What Students Think and Say About
    <span className="text-secondary"> Adhyayi</span>
  </h2>

  <p className="mx-auto mt-3 max-w-2xl text-sm text-slate-600">
    Real stories from learners who've earned while learning
  </p>
</div>

 <Swiper
  modules={[Autoplay, Pagination]}
  centeredSlides={true}
  loop={true}
  pagination={{ clickable: true }}
  autoplay={{
    delay: 2500,
    disableOnInteraction: false,
  }}
  breakpoints={{
    0: {
      slidesPerView: 1,
      spaceBetween: 12,
    },
    480: {
      slidesPerView: 1.2,
      spaceBetween: 12,
    },
    640: {
      slidesPerView: 1.5,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 24,
    },
  }}
  className="pb-12"
>
          {testimonials.map((item, index) => (
            <SwiperSlide key={index}>
              {({ isActive }) => (
  <div
  className={`
    overflow-hidden
    rounded-2xl md:rounded-3xl
    shadow-xl
    transition-all
    duration-500
    mx-2
    mb-6
    mt-2
    md:mt-8
    md:mb-16
    ${
      isActive
        ? "scale-100 md:scale-105 bg-bgBlue"
        : "scale-[0.95] bg-bgBlue/50 opacity-70"
    }
  `}
>
                 <div className="relative h-40 sm:h-48 md:h-52 lg:h-56">
  <img
    src={ReferShare}
    alt="Student"
    className="h-full w-full object-cover opacity-80"
  />

                  <div className="absolute inset-0 flex items-center justify-center">
  <div className="flex items-center justify-center h-12 w-12 md:h-14 md:w-14 rounded-full bg-white/30 backdrop-blur-md">
    <Play
      size={20}
      fill="white"
      className="text-white ml-1 md:w-6 md:h-6"
    />
  </div>
</div>
                  </div>

      <div className="p-4 md:p-6 text-white text-center">
  <h3 className="text-sm sm:text-base md:text-lg font-bold">
    {item.name}
  </h3>

  <p className="text-xs sm:text-sm text-orange-400 font-semibold mb-3">
    {item.plan}
  </p>

  <div className="flex justify-center gap-1 mb-3">
    {[...Array(5)].map((_, i) => (
      <span
        key={i}
        className="text-yellow-400 text-xs md:text-sm"
      >
        ★
      </span>
    ))}
  </div>

  <p className="text-xs sm:text-sm leading-relaxed mb-4 min-h-[50px]">
    "{item.review}"
  </p>

  <button className="w-full rounded-lg bg-secondary py-2.5 text-xs sm:text-sm font-semibold transition hover:bg-purple-700">
    Watch Full Story
  </button>
</div>
                </div>
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}